import { Icon } from '@iconify/react'
import { motion } from 'framer-motion'
import flashFill from '@iconify/icons-eva/flash-fill'
// import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import { Button, Box, Container, Typography, Stack } from '@material-ui/core'
// routes
import { PATH_DASHBOARD } from '../../../routes/paths'
//
import {
  varFadeIn,
  varFadeInUp,
  varWrapEnter,
  varFadeInRight,
} from '../../animate'
import { Link } from 'react-router-dom'

// ----------------------------------------------------------------------

const RootStyle = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  // backgroundColor: theme.palette.grey[400],
  [theme.breakpoints.up('md')]: {
    // top: 0,
    // left: 0,
    width: '100%',
    // height: '90vh',
    // display: 'flex',
    // position: 'fixed',
    alignItems: 'center',
  },
}))

const ContentStyle = styled((props) => <Stack spacing={5} {...props} />)(
  ({ theme }) => ({
    zIndex: 10,
    maxWidth: '100%',
    margin: 'auto',
    textAlign: 'center',
    position: 'relative',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      margin: 'unset',
      textAlign: 'center',
      paddingLeft: theme.spacing(15),
      paddingRight: theme.spacing(15),
    },
    [theme.breakpoints.down('md')]: {
      margin: 'unset',
      textAlign: 'center',
      paddingTop: theme.spacing(4),
    },
  }),
)

// ----------------------------------------------------------------------

export default function FreeDemoLanding() {
  return (
    <>
      <RootStyle initial="initial" animate="animate" variants={varWrapEnter}>
        {/* <HeroImgStyle alt="hero" src="/static/home/hero.png" variants={varFadeInUp} /> */}

        <Container maxWidth="lg">
          <ContentStyle>
            <motion.div variants={varFadeInRight}>
              <Typography variant="h2" sx={{ color: 'common.white'}}style={{fontSize:'2rem'}}>
              Empower Your Industry with Innovation 
                <Typography
                  component="span"
                  variant="h2"
                  sx={{ color: 'primary.main'}}
                  style={{
                    fontSize: '2rem',
                  }}
                >
                  &nbsp; Get a Free Demo
                </Typography>
              </Typography>
            </motion.div>

            {/* <motion.div variants={varFadeInRight}>
              <Typography
                sx={{
                  color: '#a3a3a3',
                  width: '100%',
                  textAlign: 'center',
                  letterSpacing: '.15px',
                  fontSize: '19px',
                  fontWeight: '500',
                  lineHeight: '160%',
                  mt: -2,
                  pl: { xs: 0, md: 18 },
                  pr: { xs: 0, md: 18 },
                }}
              >
                Tailored ERP Solutions for Every Industry Need{' '}
              </Typography>
            </motion.div> */}
            {/* <motion.div variants={varFadeInRight}></motion.div>
            <motion.div variants={varFadeInRight}></motion.div> */}
          </ContentStyle>
        </Container>
      </RootStyle>
      {/* <Box sx={{ height: { md: '70vh' } }} /> */}
    </>
  )
}
